import { ShoppingBagOutlined } from '@mui/icons-material';
import { Box, Stack } from '@mui/material';
import { FalconAvatar } from '@procureai/ui-mui';

import { AstroResponsibleUserItem } from '@/generated/gql/graphql';

import { AvailabilityBadge, OptionText, Root } from './UserOption.styled';

export interface UserOptionProps {
  data: AstroResponsibleUserItem;
}

export const UserOption = ({ data, ...props }: UserOptionProps) => {
  let avatar;

  if (!data.profilePicture) {
    avatar = <FalconAvatar alt={data.id} />;
  } else {
    avatar = <FalconAvatar alt={data.id} imageId={data.profilePicture} />;
  }

  return (
    <Root {...props}>
      <Box sx={{ position: 'relative' }}>
        <AvailabilityBadge availabilityStatus={data.availabilityStatus}>{avatar}</AvailabilityBadge>
      </Box>
      <Stack
        direction="column"
        sx={{
          ml: 3,
          width: '100%',
        }}
      >
        <OptionText variant="body2">
          {data.firstName} {data.lastName}
        </OptionText>
      </Stack>
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
        }}
      >
        <OptionText variant="body2">{data.demandCount ?? 0}</OptionText>
        <ShoppingBagOutlined />
      </Stack>
    </Root>
  );
};
